<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <div class="grid">
    <div class="md:col-12 lg:col-12 col-12">
      <app-detalle-tercero *ngIf="tercero && tercero.idTercero" [third]="tercero" [view]="false"
                           [edit]="false"
                           [clasification]="false"></app-detalle-tercero>
    </div>
  </div>
  <div class="grid">
    <div class="col-12">
      <p-panel header="{{ 'SUCURSALES.LBL_SUCURSALES' | translate}}">
        <div class="grid">
          <div class="md:col-6 lg:col-6 col-12">
            <button type="button" pButton icon="fa fa-plus" (click)="crearSucursal()"
                    *ngIf="aliado.indicadorHabilitado && !actAliado && !esDetalle"
                    label="{{ 'BTN_AGREGAR' | translate}}"></button>
          </div>
          <div class="col-12 md:col-6 lg:col-6">
            <input #gb type="text" pInputText size="40" placeholder="{{ 'LBL_BUSCAR' | translate }}"
                   (input)="dt.filterGlobal($event.target.value, 'contains')"
                   [(ngModel)]="busqueda">
          </div>
        </div>

        <div class="grid">
          <div class="col-12 md:col-12 lg:col-12">
            <p-table [columns]="columnas" [loading]="carTabla || actAliado" #dt
                     [value]="sucursales" selectionMode="single" dataKey="idAliadoSucursal"
                     [paginator]="true" [rows]="10"  paginatorPosition="bottom">
              <ng-template pTemplate="header" let-columns>
                <tr>
                  <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                    {{col.header}}
                    <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-row>
                <tr [pSelectableRow]="row">
                  <td>{{row.codigo}}</td>
                  <td>{{row.nombre}}</td>
                  <td>{{row.descripcionDivisionPolitica}}</td>
                  <td>{{row.alias}}</td>
                  <td>{{row.nombreEstructuraFisica}}</td>
                  <td>{{row.cantidadUsuarios}}</td>
                  <td>{{row.cupoValor | dinero:2}}</td>
                  <td>{{row.cupoCredito}}</td>
                  <td class="text-center">
                    <p-checkbox [(ngModel)]="row.indicadorPrincipal" binary="true" disabled="true"></p-checkbox>
                  </td>
                  <td class="text-center">
                    <p-checkbox [(ngModel)]="row.indicadorHabilitado" binary="true" disabled="true"></p-checkbox>
                  </td>
                  <td class="text-center">
                    <div class="btn-group" role="group">
                      <button type="button" class="p-button btn" icon="fa fa-eye" data-toggle="tooltip"
                              title="{{'BTN_VISUALIZAR' | translate}}"
                              pButton (click)="verSucursal(row)"></button>
                      <button type="button" class="p-button p-button-success btn" icon="fa fa-pencil" data-toggle="tooltip"
                              title="{{'BTN_EDITAR' | translate}}" pButton *ngIf="aliado.indicadorHabilitado && !esDetalle"
                              (click)="editarSucursal(row)"></button>
                    </div>
                  </td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage" let-columns>
                <tr>
                  <td [attr.colspan]="columns.length" class="text-center">
                    {{ 'MSG_NOHAYREGISTROS' | translate}}
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </p-panel>
    </div>
  </div>
  <div class="grid">
    <div class="col-12 md:col-6 lg:col-6 ">
      <p-checkbox label="{{ 'LBL_HABILITADO' | translate}}" binary="true"
                  id="idHabilitado" *ngIf="!actAliado" [disabled]="esDetalle"
                  name="nomHabilitado" (onChange)="cambioHabilitadoAliado()"
                  [(ngModel)]="indHabilitadoAliado"></p-checkbox>
      <div *ngIf="actAliado">
        <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
        <span>{{'LBL_PROCESANDO' | translate }}</span>
      </div>
    </div>
  </div>
  <div class="grid form-footer-buttons">
    <div class="form-group col-12">
      <button icon="fa fa-arrow-left" label="{{ 'BTN_REGRESAR' | translate }}" type="button"
              pButton (click)="regresar()"></button>
    </div>
  </div>
</div>
<p-confirmDialog #cd key="aliado-sucursal">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>

